import React from "react"
import { AmchartSeeker } from "@ui-seeker/core"

import { isLoadingCommonFilters } from "@signals"
import { BIChartLegendVisibility, BIIsLoadingChart } from "../../@signals"
import BIChartActions from "./PricesChartToolbar"
import { useBiChartVisibility } from "Pages/BusinessLogistics/BI/Page/@hooks"
import { AppResultsSkeleton } from "@components"


export default function BIChart({ dataChart, titleChart = '', seriesToApply, xTitle, isDateAxis, ...props }) {

	const { setIsVisible, onLegendClick } = useBiChartVisibility()

	if (BIIsLoadingChart.value || isLoadingCommonFilters.value) return <AppResultsSkeleton chart height={520}/>
	if (!dataChart?.length) return <></>

	return <AmchartSeeker
		sx={{ height: "750px" }}
		rootID="ChartSelected"
		title={titleChart}
		data={dataChart}
		series={seriesToApply.map(({ dataKey, color, is_previous_period_color }) => ({
			...is_previous_period_color && { strokes: { strokeDasharray: [4, 4] } },
			name: dataKey,
			yField: dataKey,
			hidden: !BIChartLegendVisibility.value.includes(dataKey),
			xField: 'date',
			color: color,
			tooltip: { useSingleTooltip: BIChartLegendVisibility.value.length > 14 },
			connect: true,
		}))}
		cardProps={{ actions: <BIChartActions setIsVisible={setIsVisible}/>, }}
		chartProps={{
			enabledPDF: false,
			numberFormat: `#,###.00`,
			dateFormatReceived: 'yyyyMMdd',
			scrollbarY: {
				show: true
			},
			xAxis: {
				categoryField: 'date',
				maxDeviation: 0.3,
				isDateAxis: isDateAxis,
				dateFormat: 'dd MMM yyyy',
				title: xTitle,
				baseInterval: {
					timeUnit: 'day',
					count: 1
				},
				...props.labelProps
			},
			legend: {
				onClick: onLegendClick,
				verticalScrollbar: true
			},
			yAxis: {
				title: 'Prices'
			},
		}}
	/>
}